import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navigation.css';

function Navigation() {
    const { user, logout, isAdmin } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const isActive = (path) => {
        return location.pathname === path || location.pathname.startsWith(path + '/');
    };

    return (
        <nav className="navigation">
            <div className="nav-container">
                <div className="nav-brand">
                    <h1>Effective Arbitrage</h1>
                </div>

                <div className="nav-links">
                    <button
                        className={`nav-link ${isActive('/sync-dashboard') ? 'active' : ''}`}
                        onClick={() => navigate('/sync-dashboard')}
                    >
                        Dashboard
                    </button>

                    <button
                        className={`nav-link ${isActive('/products') ? 'active' : ''}`}
                        onClick={() => navigate('/products')}
                    >
                        Products
                    </button>

                    {isAdmin() && (
                        <button
                            className={`nav-link ${isActive('/users') ? 'active' : ''}`}
                            onClick={() => navigate('/users')}
                        >
                            Users
                        </button>
                    )}

                    <button
                        className={`nav-link ${isActive('/settings') ? 'active' : ''}`}
                        onClick={() => navigate('/settings')}
                    >
                        Settings
                    </button>

                    <button
                        className={`nav-link ${isActive('/logs') ? 'active' : ''}`}
                        onClick={() => navigate('/logs')}
                    >
                        Logs
                    </button>

                    <button
                        className={`nav-link ${isActive('/stats') ? 'active' : ''}`}
                        onClick={() => navigate('/stats')}
                    >
                        Stats
                    </button>
                </div>

                <div className="nav-user">
                    <span className="user-name">
                        {user?.firstName || user?.first_name} {user?.lastName || user?.last_name}
                    </span>
                    <span className={`user-badge ${user?.role}`}>
                        {user?.role}
                    </span>
                    <button className="btn btn-logout" onClick={handleLogout}>
                        Logout
                    </button>
                </div>
            </div>
        </nav>
    );
}

export default Navigation;
